var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialTestingImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41096",
    "data-name": "Group 41096",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 430.44,
    height: 359.051,
    viewBox: "0 0 430.44 359.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-10, .cls-11, .cls-12, .cls-14, .cls-17, .cls-18, .cls-20, .cls-21, .cls-24, .cls-9 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4eb2a2;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: 0.7;\r\n      }\r\n\r\n      .cls-15, .cls-4, .cls-7 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-5 {\r\n        clip-path: url(#clip-path-3);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-7 {\r\n        opacity: 0.5;\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clip-path-4);\r\n      }\r\n\r\n      .cls-10, .cls-12, .cls-14, .cls-18, .cls-20, .cls-21, .cls-9 {\r\n        stroke: #012d35;\r\n      }\r\n\r\n      .cls-11, .cls-12, .cls-14, .cls-17, .cls-18, .cls-20, .cls-21, .cls-9 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-10, .cls-24 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-11, .cls-17 {\r\n        stroke: #4eb2a2;\r\n      }\r\n\r\n      .cls-11, .cls-12 {\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #012d35;\r\n      }\r\n\r\n      .cls-14 {\r\n        stroke-width: 1.257px;\r\n      }\r\n\r\n      .cls-15 {\r\n        opacity: 0.1;\r\n      }\r\n\r\n      .cls-16 {\r\n        clip-path: url(#clip-path-5);\r\n      }\r\n\r\n      .cls-17, .cls-18 {\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-19 {\r\n        clip-path: url(#clip-path-6);\r\n      }\r\n\r\n      .cls-20 {\r\n        stroke-width: 0.821px;\r\n      }\r\n\r\n      .cls-21 {\r\n        stroke-width: 0.725px;\r\n      }\r\n\r\n      .cls-22 {\r\n        clip-path: url(#clip-path-7);\r\n      }\r\n\r\n      .cls-23 {\r\n        clip-path: url(#clip-path-8);\r\n      }\r\n\r\n      .cls-24 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-25 {\r\n        clip-path: url(#clip-path-9);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7948",
    "data-name": "Rectangle 7948",
    className: "cls-1",
    width: 430.44,
    height: 359.051
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7926",
    "data-name": "Rectangle 7926",
    className: "cls-1",
    width: 388.279,
    height: 322.596,
    transform: "translate(22.524)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7927",
    "data-name": "Rectangle 7927",
    className: "cls-1",
    width: 423.68,
    height: 73.44,
    transform: "translate(3.17 272.891)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7930",
    "data-name": "Rectangle 7930",
    className: "cls-1",
    width: 10.335,
    height: 14.99,
    transform: "translate(362.07 330.751)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7931",
    "data-name": "Rectangle 7931",
    className: "cls-1",
    width: 115.94,
    height: 213.14,
    transform: "translate(131.61 81.021)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7941",
    "data-name": "Rectangle 7941",
    className: "cls-1",
    width: 10.7,
    height: 10.7,
    transform: "translate(183.29 283.451)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7944",
    "data-name": "Rectangle 7944",
    className: "cls-1",
    width: 9.18,
    height: 9.18,
    transform: "translate(148.58 283.081)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7946",
    "data-name": "Rectangle 7946",
    className: "cls-1",
    width: 9.798,
    height: 9.798,
    transform: "translate(221.59 283.322)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41095",
    "data-name": "Group 41095",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41094",
    "data-name": "Group 41094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41093",
    "data-name": "Group 41093",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41046",
    "data-name": "Path 41046",
    className: "cls-3",
    d: "M340.94,15.791c-34.3-15.95-75.39-20.75-112.48-10.08-33.57,9.67-60.91,32.57-88.19,53.34-27.89,21.22-62.33,35.55-86.82,60.82-33.61,34.74-40.51,89.1-17.33,131.4,23.82,43.54,71.82,62.94,118.91,68.7,61.26,7.45,135.87.88,182.18-43.86,23.89-23.08,41.83-51.82,54.46-82.41,12.81-31.06,24.17-61.7,16.81-95.88-8.03-37.28-33.46-66.16-67.54-82.03"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41074",
    "data-name": "Group 41074",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41073",
    "data-name": "Group 41073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41072",
    "data-name": "Group 41072",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41047",
    "data-name": "Path 41047",
    className: "cls-6",
    d: "M340.94,15.791c-34.3-15.95-75.39-20.75-112.48-10.08-33.57,9.67-60.91,32.57-88.19,53.34-27.89,21.22-62.33,35.55-86.82,60.82-33.61,34.74-40.51,89.1-17.33,131.4,23.82,43.54,71.82,62.94,118.91,68.7,61.26,7.45,135.87.88,182.18-43.86,23.89-23.08,41.83-51.82,54.46-82.41,12.81-31.06,24.17-61.7,16.81-95.88-8.03-37.28-33.46-66.16-67.54-82.03"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_41048",
    "data-name": "Path 41048",
    className: "cls-3",
    d: "M215.01,272.891c117,0,211.84,16.44,211.84,36.72s-94.844,36.72-211.84,36.72S3.17,329.891,3.17,309.611s94.844-36.72,211.84-36.72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41077",
    "data-name": "Group 41077",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41076",
    "data-name": "Group 41076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41075",
    "data-name": "Group 41075",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41049",
    "data-name": "Path 41049",
    className: "cls-6",
    d: "M215.01,272.891c117,0,211.84,16.44,211.84,36.72s-94.844,36.72-211.84,36.72S3.17,329.891,3.17,309.611s94.844-36.72,211.84-36.72"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_41050",
    "data-name": "Path 41050",
    className: "cls-3",
    d: "M.68,265.441l-.06,1.7.49,5.77,101.6,28.6,89.95-108.32-.8-9.32-20.73-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41051",
    "data-name": "Path 41051",
    className: "cls-6",
    d: "M191.55,183.591l-97.9-24.02L.68,265.441l99.61,28.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41052",
    "data-name": "Path 41052",
    className: "cls-9",
    d: "M191.55,183.591l-97.9-24.02L.68,265.441l99.61,28.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41053",
    "data-name": "Path 41053",
    className: "cls-9",
    d: "M191.55,183.591l.85,9.92-89.69,108-2.42-8.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41054",
    "data-name": "Path 41054",
    className: "cls-9",
    d: "M102.71,301.511l-101.6-28.6-.61-7.2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    className: "cls-9",
    x1: 85.19,
    y1: 23.93,
    transform: "translate(16.29 273.481)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    className: "cls-9",
    x1: 47.89,
    y2: 55.7,
    transform: "translate(143.99 190.561)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    className: "cls-9",
    x1: 37.22,
    y2: 44.45,
    transform: "translate(101.35 251.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41055",
    "data-name": "Path 41055",
    className: "cls-10",
    d: "M87.03,182.661c1.55,2.8,5.62,3.51,9.09,1.58s5-5.76,3.45-8.56-5.63-3.5-9.1-1.57S85.47,179.871,87.03,182.661Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    className: "cls-9",
    x1: 63.55,
    y1: 17.54,
    transform: "translate(102.15 185.681)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    className: "cls-9",
    x1: 63.56,
    y1: 17.53,
    transform: "translate(104.23 183.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41056",
    "data-name": "Path 41056",
    className: "cls-10",
    d: "M68.77,203.091c1.56,2.8,5.63,3.51,9.09,1.58s5-5.76,3.45-8.56-5.63-3.5-9.09-1.57S67.21,200.3,68.77,203.091Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    className: "cls-9",
    x1: 62.68,
    y1: 17.29,
    transform: "translate(89.37 204.621)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    className: "cls-9",
    x1: 62.75,
    y1: 17.31,
    transform: "translate(91.46 202.141)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    className: "cls-9",
    x1: 64.62,
    y1: 17.84,
    transform: "translate(73.95 218.641)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    className: "cls-9",
    x1: 64.67,
    y1: 17.85,
    transform: "translate(76.03 216.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41057",
    "data-name": "Path 41057",
    className: "cls-10",
    d: "M52.415,217.067c3.464-1.93,7.536-1.226,9.095,1.573s.014,6.631-3.45,8.561-7.536,1.225-9.1-1.573S48.951,219,52.415,217.067Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    className: "cls-9",
    x1: 64.65,
    y1: 17.83,
    transform: "translate(59.32 235.441)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    className: "cls-9",
    x1: 64.6,
    y1: 17.82,
    transform: "translate(61.41 232.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41058",
    "data-name": "Path 41058",
    className: "cls-10",
    d: "M27.83,249.761c1.55,2.79,5.63,3.5,9.09,1.57s5-5.76,3.45-8.56-5.63-3.5-9.1-1.57S26.27,246.971,27.83,249.761Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    className: "cls-9",
    x1: 63.55,
    y1: 17.54,
    transform: "translate(42.61 256.581)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    className: "cls-9",
    x1: 63.55,
    y1: 17.53,
    transform: "translate(44.7 254.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41059",
    "data-name": "Path 41059",
    className: "cls-11",
    d: "M91.14,175.3s-.63,6.08.64,6.85c1.76-1.75,10.52-9.68,10.52-9.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41060",
    "data-name": "Path 41060",
    className: "cls-11",
    d: "M53.94,219.971s-1.23,6,0,6.89c1.93-1.57,11.44-8.59,11.44-8.59"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    className: "cls-12",
    x1: 3.76,
    y1: 15.6,
    transform: "translate(73.33 191.651)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    className: "cls-12",
    x1: 3.76,
    y1: 15.6,
    transform: "translate(33.39 238.911)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    className: "cls-12",
    y1: 10.17,
    x2: 14.64,
    transform: "translate(67.21 194.451)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    className: "cls-12",
    y1: 10.17,
    x2: 14.64,
    transform: "translate(26.07 241.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41061",
    "data-name": "Path 41061",
    className: "cls-13",
    d: "M81.31,152.971l68.48,83.8a18.4,18.4,0,0,0,24.08,25.28l-14.27-17.5,6.89-5.58,14.29,17.52a18.4,18.4,0,0,0-20-28.67l-68.49-83.9c-.07-.09,1.79-4.66,1.92-5.25,1.35-5.93.83-12.73-2.76-17.79-5.84-8.22-15.93-8.78-24.71-5.43a26.292,26.292,0,0,0-6.1,3.19L78.25,138.1l-3,3.15L58.57,120.5c-7.1,2.29-11,10.64-6.74,22.53,1,2.75,11,5.27,13.18,6.89a18.379,18.379,0,0,0,16.28,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41062",
    "data-name": "Path 41062",
    className: "cls-3",
    d: "M73.74,152.971l68.48,83.8a18.4,18.4,0,0,0,24.07,25.28l-14.27-17.5,6.92-5.58,14.3,17.52a18.4,18.4,0,0,0-20-28.67l-68.49-83.9a18.4,18.4,0,0,0-24.08-25.28l13.9,17-6.91,5.57-13.9-17a18.37,18.37,0,0,0,19.94,28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41063",
    "data-name": "Path 41063",
    className: "cls-14",
    d: "M73.74,152.971l68.48,83.8a18.4,18.4,0,0,0,24.07,25.28l-14.27-17.5,6.92-5.58,14.3,17.52a18.4,18.4,0,0,0-20-28.67l-68.49-83.9a18.4,18.4,0,0,0-24.08-25.28l13.9,17-6.91,5.57-13.9-17a18.37,18.37,0,0,0,19.94,28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41064",
    "data-name": "Path 41064",
    className: "cls-13",
    d: "M80.59,148.331a2.08,2.08,0,1,1-2.09-2.07h.01a2.079,2.079,0,0,1,2.08,2.07"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    className: "cls-14",
    x2: 23.64,
    y2: 29.44,
    transform: "translate(118.29 202.681)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    className: "cls-14",
    x2: 6.25,
    y2: 7.78,
    transform: "translate(107.69 189.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41065",
    "data-name": "Path 41065",
    className: "cls-3",
    d: "M370.68,345.121l-8.61.62-8.87.63-171.14,12.18-25.73-8.06-11-3.44,10.61-5.08,24.13-11.7,169.55-12.06,10-.72,9.13-.64.42,1a39.421,39.421,0,0,1,1.51,27.27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7928",
    "data-name": "Rectangle 7928",
    className: "cls-13",
    width: 187.82,
    height: 3.49,
    transform: "matrix(0.998, -0.067, 0.067, 0.998, 179.847, 348.806)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7929",
    "data-name": "Rectangle 7929",
    className: "cls-13",
    width: 187.82,
    height: 3.49,
    transform: "translate(177.788 336.114) rotate(-3.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41066",
    "data-name": "Path 41066",
    className: "cls-6",
    d: "M370.68,345.121l-8.61.62-9.74.69c.79-11-1.54-23.94-2.74-28.27l10-.72,9.13-.64.42,1a39.421,39.421,0,0,1,1.54,27.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41067",
    "data-name": "Path 41067",
    className: "cls-6",
    d: "M182.06,358.551l-25.73-8.06-11-3.44,10.61-5.08,24.13-11.7c10.2,16,1.99,28.28,1.99,28.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41068",
    "data-name": "Path 41068",
    className: "cls-13",
    d: "M156.33,350.491l-11-3.44,10.61-5.08a13.475,13.475,0,0,1,.39,8.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41069",
    "data-name": "Path 41069",
    className: "cls-9",
    d: "M182.06,358.551s8.79-14-2-28.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41070",
    "data-name": "Path 41070",
    className: "cls-13",
    d: "M370.68,345.121l-8.61.62c.18-1.21.32-2.42.42-3.62a71.131,71.131,0,0,0-2.95-24.68l9.13-.64.42,1a39.441,39.441,0,0,1,1.59,27.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41071",
    "data-name": "Path 41071",
    className: "cls-9",
    d: "M370.68,345.121l-188.62,13.43-25.73-8.06-11-3.44,10.61-5.08,24.13-11.7,188.63-13.42.42,1a39.514,39.514,0,0,1,1.59,27.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41080",
    "data-name": "Group 41080",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41079",
    "data-name": "Group 41079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41078",
    "data-name": "Group 41078",
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41072",
    "data-name": "Path 41072",
    className: "cls-6",
    d: "M370.68,345.121l-8.61.62c.18-1.21.32-2.42.42-3.62l9.81-11.37a39.207,39.207,0,0,1-1.62,14.37"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_41073",
    "data-name": "Path 41073",
    className: "cls-10",
    d: "M349.59,318.161s3.92,18,2.74,28.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41074",
    "data-name": "Path 41074",
    className: "cls-13",
    d: "M330.75,88.711a.309.309,0,0,0,.35-.1l3.8-5.07a.291.291,0,0,0,0-.36l-3.49-4.33a25.872,25.872,0,0,0,1.88-5.54l5.5-1.28a.31.31,0,0,0,.24-.28l.18-6.33a.291.291,0,0,0-.22-.29l-5.44-1.55a25.207,25.207,0,0,0-3.66-9.46l3.05-4.85a.27.27,0,0,0,0-.35l-4.36-4.61a.3.3,0,0,0-.36-.06l-5,2.82a25.865,25.865,0,0,0-5-2.76l-.26-5.79a.27.27,0,0,0-.25-.26l-6.2-1.28a.3.3,0,0,0-.33.15l-2.53,5.24a25.427,25.427,0,0,0-5.63.57l-3.53-4.62a.319.319,0,0,0-.35-.1l-5.82,2.52a.31.31,0,0,0-.18.31l.93,5.71a25.4,25.4,0,0,0-3.19,2.56c-.37.34-.73.71-1.14,1.15l-5.5-1.73a.3.3,0,0,0-.34.12l-3.34,5.39a.291.291,0,0,0,0,.36l4,4.09a25.585,25.585,0,0,0-1.43,5.58l-5.41,1.69a.33.33,0,0,0-.21.3l.39,6.34a.29.29,0,0,0,.24.26l5.49,1.08a25.2,25.2,0,0,0,2.06,5.5l-3.38,4.52a.3.3,0,0,0,0,.37l3.94,5a.289.289,0,0,0,.3,0l5-2.23a25.451,25.451,0,0,0,4.88,3.35l-.21,5.49a.31.31,0,0,0,.21.29l6.08,1.82a.28.28,0,0,0,.33-.13l2.84-4.68a26.223,26.223,0,0,0,5.94-.08l3,4.62a.3.3,0,0,0,.34.11l6-2a.291.291,0,0,0,.19-.3l-.35-5.48a25.458,25.458,0,0,0,4.77-3.48Zm-33-32.11a12.053,12.053,0,1,1-.072.03l.032-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41075",
    "data-name": "Path 41075",
    className: "cls-10",
    d: "M273.76,94.231a.291.291,0,0,0,0-.39l-3.24-3.05a21.567,21.567,0,0,0,1.54-4.5l4.47-.38a.29.29,0,0,0,.28-.27l.2-6.59a.29.29,0,0,0-.27-.28l-4.49-.65a21.072,21.072,0,0,0-3-7.77l2.95-3.54a.28.28,0,0,0,0-.38l-4.53-4.79a.281.281,0,0,0-.39,0l-3.71,2.76a21.464,21.464,0,0,0-4-2.24l.41-4.62a.3.3,0,0,0-.23-.33l-6.47-1.33a.279.279,0,0,0-.33.19l-1.46,4.43a21.358,21.358,0,0,0-4.58.46l-2.32-4a.319.319,0,0,0-.37-.13l-6.05,2.62a.29.29,0,0,0-.17.35l1.35,4.44a23.213,23.213,0,0,0-2.62,2.1c-.29.28-.58.56-.9.92l-4.19-2a.29.29,0,0,0-.37.11l-3.55,5.6a.279.279,0,0,0,.06.39l3.59,2.82a21.694,21.694,0,0,0-1.18,4.54l-4.47.78a.29.29,0,0,0-.24.31l.38,6.59a.3.3,0,0,0,.27.28l4.47.24a20.915,20.915,0,0,0,1.66,4.47l-3.15,3.14a.281.281,0,0,0,0,.39l4.1,5.14a.281.281,0,0,0,.39,0l3.75-2.32a22,22,0,0,0,4,2.72l-.77,4.33a.289.289,0,0,0,.2.33l6.33,1.89a.291.291,0,0,0,.34-.16l1.73-4a21,21,0,0,0,4.82-.08l1.85,4a.291.291,0,0,0,.35.15l6.25-2.06a.29.29,0,0,0,.19-.34l-.9-4.28a22.318,22.318,0,0,0,3.9-2.84l3.82,2.21a.3.3,0,0,0,.38-.08Zm-31.88-3.69a12.88,12.88,0,0,1,18.74-17.67l.24.27a12.875,12.875,0,1,1-19,17.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41076",
    "data-name": "Path 41076",
    className: "cls-10",
    d: "M264.86,38.311a.169.169,0,0,0,0,.23l2.41,3a.161.161,0,0,0,.22,0l2.21-1.37a12.145,12.145,0,0,0,2.34,1.61l-.45,2.54a.149.149,0,0,0,.1.187l.01,0,3.72,1.12a.17.17,0,0,0,.2-.1l1-2.37a12.262,12.262,0,0,0,2.84,0l1.08,2.34a.18.18,0,0,0,.21.08l3.67-1.2a.18.18,0,0,0,.11-.2l-.52-2.53a13.382,13.382,0,0,0,2.29-1.66l2.24,1.3a.17.17,0,0,0,.22,0l2.32-3.11a.15.15,0,0,0,.008-.212l-.008-.008-1.9-1.8a12.378,12.378,0,0,0,.9-2.65l2.63-.22a.18.18,0,0,0,.17-.16l.11-3.88a.17.17,0,0,0-.15-.16l-2.64-.39a12.541,12.541,0,0,0-1.78-4.56l1.74-2.08a.181.181,0,0,0,0-.23l-2.66-2.86a.161.161,0,0,0-.22,0l-2.19,1.63a12.49,12.49,0,0,0-2.37-1.32l.25-2.72a.181.181,0,0,0-.14-.19l-3.8-.78a.16.16,0,0,0-.2.107v0l-.86,2.6a12.8,12.8,0,0,0-2.69.27l-1.34-2.38a.149.149,0,0,0-.2-.076l-.012.006-3.56,1.53a.181.181,0,0,0-.1.21l.79,2.61a12.136,12.136,0,0,0-1.53,1.23c-.17.16-.34.33-.54.54l-2.46-1.15a.151.151,0,0,0-.2.058l-.006.012-2,3.3a.189.189,0,0,0,0,.23l2.11,1.66a12.191,12.191,0,0,0-.69,2.67l-2.63.45a.18.18,0,0,0-.15.18l.23,3.87a.17.17,0,0,0,.16.17l2.62.14a12.559,12.559,0,0,0,1,2.63Zm18.21-2h0a7.58,7.58,0,1,1,.315-10.715l.005,0a7.57,7.57,0,0,1-.32,10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41077",
    "data-name": "Path 41077",
    className: "cls-3",
    d: "M402.89,299.391l12.67-21.95-138.12,3.78-27.61-153.79L239.69,151.3l22.26,149.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41078",
    "data-name": "Path 41078",
    className: "cls-6",
    d: "M415.56,277.441l-138.12,3.78L249.83,124.6l128.84-4.1,2.73,30.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41079",
    "data-name": "Path 41079",
    className: "cls-9",
    d: "M415.56,277.441l-138.12,3.78L249.83,124.6l128.84-4.1,2.73,30.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41080",
    "data-name": "Path 41080",
    className: "cls-9",
    d: "M415.56,277.441l-12.67,21.95-140.94,1.83L239.69,151.3l10.14-26.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41081",
    "data-name": "Path 41081",
    className: "cls-6",
    d: "M249.83,124.6s11,82.1,54.27,140.89l125.84-4.88s-48.53-83.59-51.26-140.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41082",
    "data-name": "Path 41082",
    className: "cls-9",
    d: "M249.83,124.6s11,82.1,54.27,140.89l125.84-4.88s-48.53-83.59-51.26-140.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41083",
    "data-name": "Path 41083",
    className: "cls-13",
    d: "M365.14,134.971a3.88,3.88,0,1,0,3.89-3.87h-.01a3.88,3.88,0,0,0-3.88,3.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41084",
    "data-name": "Path 41084",
    className: "cls-13",
    d: "M348.46,135.681a3.88,3.88,0,1,0,3.89-3.87h-.01a3.87,3.87,0,0,0-3.88,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41085",
    "data-name": "Path 41085",
    className: "cls-13",
    d: "M315.424,133.612a3.88,3.88,0,1,1-1.6,5.25,3.88,3.88,0,0,1,1.6-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41086",
    "data-name": "Path 41086",
    className: "cls-13",
    d: "M296.23,137.541a3.88,3.88,0,1,0,3.89-3.87h-.01a3.87,3.87,0,0,0-3.88,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41087",
    "data-name": "Path 41087",
    className: "cls-13",
    d: "M271.18,139.561a2.29,2.29,0,0,1-4.57,0,58.4,58.4,0,0,0-.87-8.92c-.85-4.81-2.52-10.43-5.83-13.7a8.589,8.589,0,0,0-6.31-2.63h-.09a5.921,5.921,0,0,0-4.94,2.21c-2.9,3.69-2.61,11.31-1.89,16.39l-3,8c-.3-1.35-4.52-19.76,1.34-27.22a10.5,10.5,0,0,1,8.5-4,13.238,13.238,0,0,1,9.65,4c7.92,7.91,8.01,25.14,8.01,25.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41088",
    "data-name": "Path 41088",
    className: "cls-13",
    d: "M286.8,138.371a2.28,2.28,0,0,1-4.56,0,59.051,59.051,0,0,0-.88-8.92c-.84-4.82-2.51-10.43-5.82-13.71a8.509,8.509,0,0,0-6.4-2.63,6,6,0,0,0-4.94,2.22c-1.65,2.1-2.26,5.46-2.36,8.89l-4.56.14c.1-4.27.9-8.77,3.33-11.85a10.437,10.437,0,0,1,8.49-4,13.12,13.12,0,0,1,9.66,4c7.95,7.89,8.04,25.13,8.04,25.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41089",
    "data-name": "Path 41089",
    className: "cls-13",
    d: "M302.78,138.371a2.29,2.29,0,0,1-4.57,0,58.4,58.4,0,0,0-.87-8.92c-.84-4.82-2.52-10.43-5.83-13.71a8.54,8.54,0,0,0-6.4-2.63,5.929,5.929,0,0,0-4.93,2.22c-1.57,2-2.21,5.12-2.35,8.37l-4.56.15c.15-4.11,1-8.37,3.32-11.34a10.43,10.43,0,0,1,8.49-4,13.069,13.069,0,0,1,9.65,4c7.96,7.89,8.05,25.13,8.05,25.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41090",
    "data-name": "Path 41090",
    className: "cls-13",
    d: "M318.87,136.341a2.28,2.28,0,0,1-4.56,0,59.052,59.052,0,0,0-.88-8.92c-.85-4.81-2.53-10.43-5.82-13.7a8.613,8.613,0,0,0-6.32-2.63h-.08a5.909,5.909,0,0,0-4.94,2.21c-1.81,2.3-2.38,6.13-2.38,9.91l-4.55.13c0-4.55.72-9.52,3.34-12.86a10.5,10.5,0,0,1,8.49-4h.12a13.12,13.12,0,0,1,9.54,4c7.95,7.89,8.04,25.13,8.04,25.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41091",
    "data-name": "Path 41091",
    className: "cls-13",
    d: "M335.94,135.4a2.29,2.29,0,1,1-4.57.3,2.178,2.178,0,0,1,0-.3,58.4,58.4,0,0,0-.87-8.92c-.85-4.81-2.52-10.43-5.83-13.7a8.541,8.541,0,0,0-6.4-2.64,6,6,0,0,0-4.94,2.22c-1.86,2.37-2.41,6.33-2.38,10.2H306.4c0-4.59.69-9.65,3.34-13a10.5,10.5,0,0,1,8.49-4,13.141,13.141,0,0,1,9.66,4c7.92,7.88,8.05,25.12,8.05,25.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41092",
    "data-name": "Path 41092",
    className: "cls-13",
    d: "M354.65,136.341a2.28,2.28,0,0,1-4.56,0v0a57.523,57.523,0,0,0-.88-8.92c-.85-4.81-2.52-10.43-5.82-13.7a8.613,8.613,0,0,0-6.32-2.63h-.08a5.909,5.909,0,0,0-4.94,2.21c-1.63,2.08-2.26,5.41-2.36,8.83l-4.55.08c.1-4.22.92-8.67,3.32-11.73a10.5,10.5,0,0,1,8.49-4h.12a13.12,13.12,0,0,1,9.54,4c7.95,7.89,8.04,25.13,8.04,25.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41093",
    "data-name": "Path 41093",
    className: "cls-13",
    d: "M371.6,135.4a2.29,2.29,0,0,1-4.57,0,58.4,58.4,0,0,0-.87-8.92c-.85-4.81-2.52-10.43-5.83-13.7a8.5,8.5,0,0,0-6.39-2.64,6,6,0,0,0-4.95,2.22c-1.69,2.15-2.3,5.62-2.37,9.13l-4.55.16c.07-4.34.86-9,3.33-12.11a10.508,10.508,0,0,1,8.5-4,13.168,13.168,0,0,1,9.65,4c7.96,7.9,8.05,25.14,8.05,25.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41094",
    "data-name": "Path 41094",
    className: "cls-13",
    d: "M264.28,138.841a3.88,3.88,0,1,0,3.89-3.87h-.01a3.87,3.87,0,0,0-3.88,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41095",
    "data-name": "Path 41095",
    className: "cls-13",
    d: "M330.51,136.341a3.88,3.88,0,1,0,3.88-3.88,3.88,3.88,0,0,0-3.88,3.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41096",
    "data-name": "Path 41096",
    className: "cls-13",
    d: "M280.25,138.061a3.88,3.88,0,1,0,3.89-3.87h-.01a3.88,3.88,0,0,0-3.88,3.87"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    className: "cls-9",
    x2: 6.41,
    y2: 38.89,
    transform: "translate(242.31 145.141)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    className: "cls-9",
    x2: 5.51,
    y2: 32.1,
    transform: "translate(249.83 170.281)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    className: "cls-9",
    x1: 98.59,
    y2: 1.25,
    transform: "translate(269.29 290.661)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    className: "cls-9",
    x1: 15.49,
    y2: 20,
    transform: "translate(261.95 281.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41097",
    "data-name": "Path 41097",
    className: "cls-9",
    d: "M263.59,232.591l10.1,53.46,40.11-1.26"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    className: "cls-9",
    x1: 10.1,
    y1: 53.46,
    transform: "translate(253.49 205.861)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    className: "cls-9",
    x1: 61.63,
    y2: 1.51,
    transform: "translate(349.83 284.551)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    className: "cls-9",
    y1: 1.79,
    x2: 65.45,
    transform: "translate(286.89 218.441)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    className: "cls-9",
    y1: 1.98,
    x2: 72.43,
    transform: "translate(288.8 222.601)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    className: "cls-9",
    y1: 1.66,
    x2: 60.89,
    transform: "translate(291.45 228.181)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    className: "cls-9",
    y1: 1.85,
    x2: 67.67,
    transform: "translate(294.29 233.251)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    className: "cls-9",
    y1: 1.92,
    x2: 69.95,
    transform: "translate(275.47 190.451)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    className: "cls-9",
    y1: 2.04,
    x2: 74.38,
    transform: "translate(277.96 194.291)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    className: "cls-9",
    y1: 1.58,
    x2: 57.82,
    transform: "translate(279.25 198.851)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    className: "cls-9",
    y1: 1.82,
    x2: 66.66,
    transform: "translate(268.01 164.701)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    className: "cls-9",
    y1: 1.23,
    x2: 45.18,
    transform: "translate(269.54 169.661)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    className: "cls-9",
    y1: 2.05,
    x2: 75.25,
    transform: "translate(266.93 159.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41098",
    "data-name": "Path 41098",
    className: "cls-6",
    d: "M349.283,159.685c1.808-4.019,7.3-5.465,12.275-3.229s7.535,7.308,5.727,11.327-7.3,5.465-12.275,3.229-7.535-7.308-5.727-11.327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41099",
    "data-name": "Path 41099",
    className: "cls-9",
    d: "M349.283,159.685c1.808-4.019,7.3-5.465,12.275-3.229s7.535,7.308,5.727,11.327-7.3,5.465-12.275,3.229S347.475,163.7,349.283,159.685Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41100",
    "data-name": "Path 41100",
    className: "cls-17",
    d: "M352.34,160.961l8.03,6.11,9.75-19.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41101",
    "data-name": "Path 41101",
    className: "cls-6",
    d: "M358.894,186.4c1.808-4.019,7.3-5.465,12.275-3.229s7.535,7.308,5.727,11.327-7.3,5.465-12.275,3.229-7.535-7.308-5.727-11.327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41102",
    "data-name": "Path 41102",
    className: "cls-9",
    d: "M358.894,186.4c1.808-4.019,7.3-5.465,12.275-3.229s7.535,7.308,5.727,11.327-7.3,5.465-12.275,3.229S357.086,190.418,358.894,186.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41103",
    "data-name": "Path 41103",
    className: "cls-6",
    d: "M389.37,222.971c-1.8,4-7.3,5.46-12.27,3.23s-7.53-7.31-5.73-11.32,7.3-5.47,12.27-3.23,7.54,7.32,5.73,11.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41104",
    "data-name": "Path 41104",
    className: "cls-9",
    d: "M389.37,222.971c-1.8,4-7.3,5.46-12.27,3.23s-7.53-7.31-5.73-11.32,7.3-5.47,12.27-3.23S391.18,218.971,389.37,222.971Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41105",
    "data-name": "Path 41105",
    className: "cls-17",
    d: "M374.45,214.951l8.03,6.11,9.74-19.88"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    className: "cls-18",
    x2: 21.72,
    y2: 19.21,
    transform: "translate(358.18 180.841)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    className: "cls-18",
    y1: 24.5,
    x2: 9.64,
    transform: "translate(363.03 178.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41106",
    "data-name": "Path 41106",
    className: "cls-13",
    d: "M247.55,90.221v201.17a9.392,9.392,0,0,1-.42,2.77,9.2,9.2,0,0,1-8.78,6.44H138.94a9.2,9.2,0,0,1-9.2-9.2V90.221a9.221,9.221,0,0,1,9.2-9.2h99.42a9.2,9.2,0,0,1,9.19,9.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41083",
    "data-name": "Group 41083",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41082",
    "data-name": "Group 41082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41081",
    "data-name": "Group 41081",
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41107",
    "data-name": "Path 41107",
    className: "cls-6",
    d: "M247.55,90.221v201.17a9.392,9.392,0,0,1-.42,2.77L131.61,84.661a9.161,9.161,0,0,1,7.32-3.64h99.42a9.2,9.2,0,0,1,9.2,9.2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_41108",
    "data-name": "Path 41108",
    className: "cls-10",
    d: "M247.55,90.221v201.17a9.392,9.392,0,0,1-.42,2.77,9.2,9.2,0,0,1-8.78,6.44H138.94a9.2,9.2,0,0,1-9.2-9.2V90.221a9.221,9.221,0,0,1,9.2-9.2h99.42A9.2,9.2,0,0,1,247.55,90.221Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7932",
    "data-name": "Rectangle 7932",
    className: "cls-6",
    width: 105.38,
    height: 174.47,
    transform: "translate(136.05 101.621)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7933",
    "data-name": "Rectangle 7933",
    className: "cls-13",
    width: 2.38,
    height: 3.25,
    transform: "translate(141.13 109.731)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7934",
    "data-name": "Rectangle 7934",
    className: "cls-13",
    width: 2.38,
    height: 5.5,
    transform: "translate(144.38 107.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7935",
    "data-name": "Rectangle 7935",
    className: "cls-13",
    width: 2.38,
    height: 8.52,
    transform: "translate(147.88 104.461)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7936",
    "data-name": "Rectangle 7936",
    className: "cls-20",
    width: 9.44,
    height: 5.17,
    transform: "translate(228.43 107.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7937",
    "data-name": "Rectangle 7937",
    className: "cls-13",
    width: 7.36,
    height: 5.17,
    transform: "translate(228.43 107.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7938",
    "data-name": "Rectangle 7938",
    className: "cls-21",
    width: 7.36,
    height: 5.17,
    transform: "translate(228.43 107.481)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7939",
    "data-name": "Rectangle 7939",
    className: "cls-13",
    width: 1.33,
    height: 2.28,
    transform: "translate(237.85 108.931)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7940",
    "data-name": "Rectangle 7940",
    className: "cls-21",
    width: 1.33,
    height: 2.28,
    transform: "translate(237.85 108.931)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41086",
    "data-name": "Group 41086",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41085",
    "data-name": "Group 41085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41084",
    "data-name": "Group 41084",
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41109",
    "data-name": "Path 41109",
    className: "cls-6",
    d: "M188.64,283.451a5.35,5.35,0,1,1-5.35,5.35,5.35,5.35,0,0,1,5.35-5.35"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7942",
    "data-name": "Rectangle 7942",
    className: "cls-10",
    width: 105.38,
    height: 174.47,
    transform: "translate(136.05 101.621)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41089",
    "data-name": "Group 41089",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41088",
    "data-name": "Group 41088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41087",
    "data-name": "Group 41087",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7943",
    "data-name": "Rectangle 7943",
    className: "cls-24",
    width: 8.18,
    height: 8.18,
    transform: "translate(149.08 283.581)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_41110",
    "data-name": "Path 41110",
    className: "cls-3",
    d: "M225.6,144.831a.269.269,0,0,0-.26-.23l-5.25-.41a24.24,24.24,0,0,0-2.6-4.9l2.7-4.62a.279.279,0,0,0,0-.34l-4.25-4.25a.271.271,0,0,0-.34,0l-4.66,2.7a23.7,23.7,0,0,0-8.9-3.63l-1.33-5.27a.271.271,0,0,0-.27-.21h-6a.28.28,0,0,0-.27.21l-1.34,5.3a24.121,24.121,0,0,0-5.13,1.63l-4.15-3.59a.291.291,0,0,0-.35,0l-4.92,3.45a.269.269,0,0,0-.1.32l2,5.15a24.583,24.583,0,0,0-3.27,4.26l-5.48-.57a.3.3,0,0,0-.3.18l-2.05,5.64a.28.28,0,0,0,.11.33l4.54,3.08a23.663,23.663,0,0,0-.32,3.86,13.478,13.478,0,0,0,.06,1.53l-4.78,2.68a.261.261,0,0,0-.13.31l1.54,5.8a.26.26,0,0,0,.27.21l5.4-.07a24.92,24.92,0,0,0,2.87,4.59l-2.33,4.84a.27.27,0,0,0,.08.34l4.61,3.86a.271.271,0,0,0,.34,0l4.32-3.08a24.1,24.1,0,0,0,5.12,2.16l.89,5.24a.3.3,0,0,0,.26.23l6,.51a.311.311,0,0,0,.22-.18l1.74-4.93a23.992,23.992,0,0,0,5.49-1.19l3.66,3.71a.29.29,0,0,0,.33.06l5.2-3a.281.281,0,0,0,.13-.31l-1.38-5a24.486,24.486,0,0,0,3.8-4.15l5.14.94a.249.249,0,0,0,.29-.16l2.54-5.44a.289.289,0,0,0-.07-.34l-4-3.3a23.827,23.827,0,0,0,.7-5.57l4.77-2.17a.28.28,0,0,0,.17-.3Zm-28,22.84a14.714,14.714,0,1,1,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41111",
    "data-name": "Path 41111",
    className: "cls-9",
    d: "M225.6,144.831a.269.269,0,0,0-.26-.23l-5.25-.41a24.24,24.24,0,0,0-2.6-4.9l2.7-4.62a.279.279,0,0,0,0-.34l-4.25-4.25a.271.271,0,0,0-.34,0l-4.66,2.7a23.7,23.7,0,0,0-8.9-3.63l-1.33-5.27a.271.271,0,0,0-.27-.21h-6a.28.28,0,0,0-.27.21l-1.34,5.3a24.121,24.121,0,0,0-5.13,1.63l-4.15-3.59a.291.291,0,0,0-.35,0l-4.92,3.45a.269.269,0,0,0-.1.32l2,5.15a24.583,24.583,0,0,0-3.27,4.26l-5.48-.57a.3.3,0,0,0-.3.18l-2.05,5.64a.28.28,0,0,0,.11.33l4.54,3.08a23.663,23.663,0,0,0-.32,3.86,13.478,13.478,0,0,0,.06,1.53l-4.78,2.68a.261.261,0,0,0-.13.31l1.54,5.8a.26.26,0,0,0,.27.21l5.4-.07a24.92,24.92,0,0,0,2.87,4.59l-2.33,4.84a.27.27,0,0,0,.08.34l4.61,3.86a.271.271,0,0,0,.34,0l4.32-3.08a24.1,24.1,0,0,0,5.12,2.16l.89,5.24a.3.3,0,0,0,.26.23l6,.51a.311.311,0,0,0,.22-.18l1.74-4.93a23.992,23.992,0,0,0,5.49-1.19l3.66,3.71a.29.29,0,0,0,.33.06l5.2-3a.281.281,0,0,0,.13-.31l-1.38-5a24.486,24.486,0,0,0,3.8-4.15l5.14.94a.249.249,0,0,0,.29-.16l2.54-5.44a.289.289,0,0,0-.07-.34l-4-3.3a23.827,23.827,0,0,0,.7-5.57l4.77-2.17a.28.28,0,0,0,.17-.3Zm-28,22.84a14.714,14.714,0,1,1,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41112",
    "data-name": "Path 41112",
    className: "cls-3",
    d: "M193.2,193.971a.271.271,0,0,0-.29-.23l-4.21.26a19.3,19.3,0,0,0-2.12-4l2.66-3.34a.29.29,0,0,0,0-.37l-4.42-4.42a.29.29,0,0,0-.37,0l-3.37,2.68a19.644,19.644,0,0,0-7.31-3l-.52-4.34a.27.27,0,0,0-.295-.242l-.015,0h-6.25a.29.29,0,0,0-.28.25l-.51,4.37a19.553,19.553,0,0,0-4.16,1.3l-2.92-3.29a.27.27,0,0,0-.37,0l-5.13,3.59a.28.28,0,0,0-.09.36l2.11,3.88a19.748,19.748,0,0,0-2.67,3.45l-4.29-1a.28.28,0,0,0-.33.17l-2.11,5.8a.26.26,0,0,0,.128.345l.012.005,3.93,2a20.767,20.767,0,0,0-.25,3.16v1.22l-4.07,1.61a.27.27,0,0,0-.17.33l1.62,6a.26.26,0,0,0,.3.21l4.28-.64a20.268,20.268,0,0,0,2.37,3.77l-2.38,3.58a.3.3,0,0,0,0,.38l4.8,4a.3.3,0,0,0,.36,0l3.09-2.93a20,20,0,0,0,4.15,1.76l.12,4.22a.259.259,0,0,0,.25.26l6.22.52a.291.291,0,0,0,.29-.24l.84-4.1a19.847,19.847,0,0,0,4.45-1l2.49,3.34a.27.27,0,0,0,.36.07l5.41-3.12a.271.271,0,0,0,.11-.35l-1.65-3.81a20.118,20.118,0,0,0,3.09-3.37l3.93,1.31a.28.28,0,0,0,.34-.15l2.65-5.64a.28.28,0,0,0-.11-.35l-3.54-2.18a20.314,20.314,0,0,0,.58-4.52l4-1.2a.29.29,0,0,0,.2-.31Zm-11.08,7.38a9.654,9.654,0,1,1,.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41113",
    "data-name": "Path 41113",
    className: "cls-9",
    d: "M193.2,193.971a.271.271,0,0,0-.29-.23l-4.21.26a19.3,19.3,0,0,0-2.12-4l2.66-3.34a.29.29,0,0,0,0-.37l-4.42-4.42a.29.29,0,0,0-.37,0l-3.37,2.68a19.644,19.644,0,0,0-7.31-3l-.52-4.34a.27.27,0,0,0-.295-.242l-.015,0h-6.25a.29.29,0,0,0-.28.25l-.51,4.37a19.553,19.553,0,0,0-4.16,1.3l-2.92-3.29a.27.27,0,0,0-.37,0l-5.13,3.59a.28.28,0,0,0-.09.36l2.11,3.88a19.748,19.748,0,0,0-2.67,3.45l-4.29-1a.28.28,0,0,0-.33.17l-2.11,5.8a.26.26,0,0,0,.128.345l.012.005,3.93,2a20.767,20.767,0,0,0-.25,3.16v1.22l-4.07,1.61a.27.27,0,0,0-.17.33l1.62,6a.26.26,0,0,0,.3.21l4.28-.64a20.268,20.268,0,0,0,2.37,3.77l-2.38,3.58a.3.3,0,0,0,0,.38l4.8,4a.3.3,0,0,0,.36,0l3.09-2.93a20,20,0,0,0,4.15,1.76l.12,4.22a.259.259,0,0,0,.25.26l6.22.52a.291.291,0,0,0,.29-.24l.84-4.1a19.847,19.847,0,0,0,4.45-1l2.49,3.34a.27.27,0,0,0,.36.07l5.41-3.12a.271.271,0,0,0,.11-.35l-1.65-3.81a20.118,20.118,0,0,0,3.09-3.37l3.93,1.31a.28.28,0,0,0,.34-.15l2.65-5.64a.28.28,0,0,0-.11-.35l-3.54-2.18a20.314,20.314,0,0,0,.58-4.52l4-1.2a.29.29,0,0,0,.2-.31Zm-11.08,7.38a9.654,9.654,0,1,1,.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41114",
    "data-name": "Path 41114",
    className: "cls-3",
    d: "M170.39,238.551h35.33a10.949,10.949,0,0,1,10.95,10.95v.57a10.949,10.949,0,0,1-10.95,10.95H170.39a10.949,10.949,0,0,1-10.95-10.95v-.57a10.949,10.949,0,0,1,10.95-10.95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7945",
    "data-name": "Rectangle 7945",
    className: "cls-9",
    width: 57.23,
    height: 22.47,
    rx: 10.95,
    transform: "translate(159.44 238.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41115",
    "data-name": "Path 41115",
    className: "cls-13",
    d: "M169.51,249.221a4,4,0,0,1,6.83-2.54l-.88.82a2.607,2.607,0,0,0-2-.85,2.58,2.58,0,1,0-.321,5.15,2.455,2.455,0,0,0,.321,0,2.559,2.559,0,0,0,2-.87l.88.84a4,4,0,0,1-6.83-2.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41116",
    "data-name": "Path 41116",
    className: "cls-13",
    d: "M184.16,245.561v7.33H182.8v-3.14h-3.79v3.14h-1.36v-7.33h1.36v3h3.79v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41117",
    "data-name": "Path 41117",
    className: "cls-13",
    d: "M191.63,251.751v1.14h-5.49v-7.33h5.35v1.14h-4v1.9h3.54v1.12h-3.54v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41118",
    "data-name": "Path 41118",
    className: "cls-13",
    d: "M192.6,249.221a4,4,0,0,1,6.83-2.54l-.88.82a2.657,2.657,0,1,0-2.321,4.3,2.455,2.455,0,0,0,.321,0,2.53,2.53,0,0,0,2-.87l.88.84a4,4,0,0,1-6.83-2.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41119",
    "data-name": "Path 41119",
    className: "cls-13",
    d: "M203.27,249.821l-1.17,1.15v1.88h-1.36v-7.33h1.36v3.76l3.63-3.76h1.53l-3.08,3.27,3.26,4.06h-1.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41092",
    "data-name": "Group 41092",
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41091",
    "data-name": "Group 41091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41090",
    "data-name": "Group 41090",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41120",
    "data-name": "Path 41120",
    className: "cls-24",
    d: "M222.09,292.311v-8.18l8.18,4.09Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialTestingImg);
export default __webpack_public_path__ + "static/media/material_testing_Img.33b08647e25980db66707265f6e6c05b.svg";
export { ForwardRef as ReactComponent };